export const sqUnitSup = <sup>2</sup>;
export const getLabelWithSqUnit = (label: string) => (
    <>
        {label}
        {sqUnitSup}
    </>
);
